import React, { useEffect, useMemo } from 'react';

import { usePipelineCategoriesQuery } from '@/features/pipeline';
import { DSSelect } from '@hundred5/design-system';
import { useAddCandidateModal } from '../add-candidate-modal-context';

export function StageSelector() {
  const { jobOpeningIdSelected, stageIdSelected, selectStageId } =
    useAddCandidateModal();

  const pipelineCategoriesQuery = usePipelineCategoriesQuery(
    { jobOpeningId: jobOpeningIdSelected! },
    { enabled: !!jobOpeningIdSelected }
  );

  const pipelineCategories = useMemo(
    () => pipelineCategoriesQuery.data || [],
    [pipelineCategoriesQuery.data]
  );

  useEffect(() => {
    if (!stageIdSelected && !pipelineCategoriesQuery.isFetching) {
      const nonSystemCategories = pipelineCategories.filter(
        (category) => !category.isSystem
      );
      if (nonSystemCategories.length > 0) {
        selectStageId(nonSystemCategories[0].id);
      }
    }
  }, [
    stageIdSelected,
    pipelineCategories,
    pipelineCategoriesQuery.isFetching,
    selectStageId,
  ]);

  return (
    <DSSelect
      items={pipelineCategories.map((candidateCategory) => ({
        id: candidateCategory.id,
        label: candidateCategory.name,
        labelText: candidateCategory.name,
        disabled: candidateCategory.isSystem,
      }))}
      disabled={!jobOpeningIdSelected || !pipelineCategories.length}
      placeholder="Select stage"
      selectedItemId={stageIdSelected}
      onChange={(selected) => {
        if (selected) {
          selectStageId(selected.id);
        }
      }}
    />
  );
}
